export default "__VITE_ASSET__ca372f0b__"